import { Box, Button, Typography } from "@mui/material";
import { SimpleTreeView, TreeItem } from "@mui/x-tree-view";
import { User } from "../type/user";
import { sortedUsers } from "../utils/util";
import { Enterprise } from "../type";

export const renderEnterpriseTree = (
    users: User[],
    enterprises: Enterprise[],
    isSelectedTree: boolean,
    selectedEnterpriseUsers: User[],
    setSelectedEnterpriseUsers: React.Dispatch<React.SetStateAction<User[]>>,
    enterpriseUsers: User[],
    setEnterpriseUsers: React.Dispatch<React.SetStateAction<User[]>>,
    viewOnly: boolean = false
  ) => {
    const grouped = users.reduce((acc, user) => {
      const eid = user.enterpriseId!;
      if (!acc[eid]) acc[eid] = [];
      acc[eid].push(user);
      return acc;
    }, {} as Record<string, User[]>);

    return (
      <SimpleTreeView>
        {Object.entries(grouped).map(([enterpriseId, members]) => (
          <TreeItem
            itemId={`enterprise-${enterpriseId}`} 
            // label={enterprises.find(e => e.enterpriseId === enterpriseId)?.enterpriseName} key={enterpriseId}
            label={
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography>{enterprises.find(e => e.enterpriseId === enterpriseId)?.enterpriseName}</Typography>
                {viewOnly ? null : (
                    <Button
                    size="small"
                    variant="outlined"
                    sx={{ minWidth: '60px', padding: '4px 8px' }}
                    onClick={() => {
                        const enterpriseUsersToMove = members;
                        if (isSelectedTree) {
                        setSelectedEnterpriseUsers(prev =>
                            sortedUsers(prev.filter(u => u.enterpriseId !== enterpriseId))
                        );
                        setEnterpriseUsers(prev => sortedUsers([...prev, ...enterpriseUsersToMove]));
                        } else {
                        setEnterpriseUsers(prev =>
                            sortedUsers(prev.filter(u => u.enterpriseId !== enterpriseId))
                        );
                        setSelectedEnterpriseUsers(prev => sortedUsers([...prev, ...enterpriseUsersToMove]));
                        }

                    }}
                    >
                    {isSelectedTree ? '기업 미선택' : '기업 선택'}
                    </Button>
                )}
              </Box>
            }
          >
            {members.map(user => (
              <TreeItem
                itemId={`user-${user.uid}`}
                label={
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography>{user.displayName}</Typography>
                    <Typography>{user.email}</Typography>
                    <Typography>{user.phoneNumber}</Typography>
                    {viewOnly ? null : (
                        <Button
                        size="small"
                        sx={{ minWidth: '60px', padding: '4px 8px' }}
                        onClick={() => {
                            if (isSelectedTree) {
                            setSelectedEnterpriseUsers(sortedUsers(selectedEnterpriseUsers.filter(u => u.uid !== user.uid)));
                            setEnterpriseUsers(sortedUsers([...enterpriseUsers, user]));
                            } else {
                            setEnterpriseUsers(sortedUsers(enterpriseUsers.filter(u => u.uid !== user.uid)));
                            setSelectedEnterpriseUsers(sortedUsers([...selectedEnterpriseUsers, user]));
                            }
                        }}>
                        {isSelectedTree ? '미선택' : '선택'}
                        </Button>
                    )}
                  </Box>
                }
                key={user.uid}
              />
            ))}
          </TreeItem>
        ))}
      </SimpleTreeView>
    );
  };